export default "__VITE_ASSET__DGC6LJtC__"